export default __webpack_public_path__ + "static/media/icon-stoop.367a3381.svg";